import { render } from "./SupplementaryReportView.vue?vue&type=template&id=8afb245c"
import script from "./SupplementaryReportView.vue?vue&type=script&lang=js"
export * from "./SupplementaryReportView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/SupplementaryReportView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8afb245c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8afb245c', __exports__)) {
    console.log('reload')
    api.reload('8afb245c', __exports__)
  }
  
  module.hot.accept("./SupplementaryReportView.vue?vue&type=template&id=8afb245c", () => {
    console.log('re-render')
    api.rerender('8afb245c', render)
  })

}


export default __exports__